import * as React from 'react';
import BaggageSummary from '../../../ServiceSummary/services/BaggageSummary';
const Animal = ({ onServiceDelete }) => {
    return (React.createElement(BaggageSummary, { onServiceDelete: onServiceDelete, isAnimalBaggage: true }, content => React.createElement(React.Fragment, null, content)));
};
export default Animal;
